import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-spinner-loader',
  templateUrl: './spinner-loader.component.html',
  styleUrls: ['./spinner-loader.component.scss']
})
export class SpinnerLoaderComponent implements OnInit {

    constructor(@Inject(MAT_DIALOG_DATA) public data: {text: string, parameter: any | undefined}) { }

    ngOnInit(): void {}

}
